// extracted by mini-css-extract-plugin
module.exports = {"left-arrow":"_1eXK7"};